module.exports = __webpack_public_path__ + "img/withdrawal-money-ico.a771461a.svg";